export default __webpack_public_path__ + "static/AzoSansMedium-75b140b16531f51d1ad99e6f801c109b.woff";